import { RouteObject } from "react-router-dom";
import React from "react";
import UsagePage from "../Pages/Ai/UsagePage";

const AiRouting: RouteObject[] = [
    {
        index: true,
        element: <UsagePage />,
    },
];

export default AiRouting;
